import axios from 'axios';
import CONFIG from '@/config/index';
import { useUserStore } from '@/stores/userStore';

const api = axios.create({
  baseURL: `${CONFIG.API_BASE_URL}${CONFIG.API_PREFIX}`,
  timeout: 120000, // 将超时时间从30秒增加到120秒，以适应AI生成的长耗时请求
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.log('API拦截器捕获到错误:', error);
    // 处理网络错误或CORS错误等情况，这些情况下error.response可能不存在
    if (error.response) {
      // 服务器返回了错误响应
      const { status } = error.response;
      if (status === 401) {
        console.log('API拦截器捕获401错误，清除token并跳转到登录页');
        localStorage.removeItem('token');
        const userStore = useUserStore();
        userStore.logout();
        window.location.href = '/login';
      } else if (status === 403) {
        // 处理403错误
        console.log('API拦截器捕获403错误，清除token并跳转到登录页');
        localStorage.removeItem('token');
        const userStore = useUserStore();
        userStore.logout();
        window.location.href = '/login';
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应（如网络错误、CORS错误等）
      console.log('API拦截器捕获到网络错误或CORS错误:', error.request);
      // 检查请求URL是否指向我们的API端点
      if (error.request.responseURL && 
          (error.request.responseURL.includes('/api/dict/') || 
           error.request.responseURL.includes('/api/knowledge/'))) {
        console.log('检测到对API端点的请求失败，可能是认证问题，清除token并跳转到登录页');
        localStorage.removeItem('token');
        const userStore = useUserStore();
        userStore.logout();
        window.location.href = '/login';
      }
    } else {
      // 其他错误
      console.log('API拦截器捕获到其他错误:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;